import { ResponseError } from '@saaga/billingv2-sdk'

export const parseBillingError = async (err: unknown): Promise<string> => {
  if (err instanceof ResponseError) {
    try {
      const body = await err.response.json()
      if (body.message) {
        return Array.isArray(body.message) ? body.message[0] : body.message
      }
    } catch {
      // Failed to parse response body
    }
    return `Request failed (${err.response.status})`
  }

  if (err instanceof Error) {
    return err.message
  }

  return 'An unexpected error occurred'
}
